import {Chart, ChartEvent, ActiveElement} from 'chart.js';
import {isMobile} from 'react-device-detect';
import {NavigateFunction} from 'react-router';

function clickHandler(
    event: ChartEvent,
    elements: ActiveElement[],
    chart: Chart,
    navigate: NavigateFunction,
    openLevelProblem: (level: number) => void
) {
    if (!elements.length || !chart.data.labels) return;

    const firstPoint = elements[0];
    const label = chart.data.labels[firstPoint.index] as string | undefined;
    const value = chart.data.datasets[firstPoint.datasetIndex].data[
        firstPoint.index
    ] as number | undefined;

    if (label === undefined || value === undefined) return;

    if (value !== 100 && !isMobile) {
        openLevelProblem(firstPoint.index);
    } else {
        navigate('/levels');
    }
}

export default clickHandler;
